import { createApp } from 'vue'
import * as Sentry from '@sentry/vue'
import { VuePages } from '@/Shared/AutoGenerated/VuePageEnum'
import useEnvVariable from '@/Shared/Hook/useEnvVariable'

const container = document.getElementById('app')
const pageName = container?.dataset?.page
const serializedProps = container?.dataset?.props ?? '{}'
const props = JSON.parse(serializedProps)

if (typeof pageName !== 'string') {
    throw new Error(`Invalid page "${pageName}".`)
}

// @ts-ignore
const page = VuePages[pageName] ?? null

if (!page) {
    throw new Error(`Page "${pageName}" cannot be loaded.`)
}

const app = createApp(page, props)

Sentry.init({
    app: app,
    dsn: useEnvVariable().getSentryDsn(),
    trackComponents: true,
})

app.mount('#app')
